import { useCallback } from 'react';
import { useAuth0 } from '../react-auth0-spa';
import { clearSelfServiceCache } from '../common/selfServiceSolutions';

/**
 * The app's sign-out: drop what is cached about the self-service tenant, then
 * end the Auth0 session. One place, because the top bar, the sidebar, the
 * "Cancel account" dialog and the "This account has been closed" screen all
 * sign out the same way (#1379).
 */
export const useSignOut = (): (() => void) => {
    const { logout } = useAuth0();
    return useCallback(() => {
        clearSelfServiceCache();
        logout();
    }, [logout]);
};
